import React, { useState } from 'react';
import axios from '../../../plugins/axios';
import styles from './clientMainData.module.css';
import getBirthDateFromIIN from '../../../utils/getBirthDateFromIIN';
import { get } from 'react-hook-form';
import editProfile from '../../../api/clients/editProfile';
import api from '../../../plugins/api';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import checkCrmSidebarNotifications from '../../../api/notifications/checkCrmSidebarNotifications';
import getClients from '../../../api/clients/getClients';

// components
import ClientCheck from '../../../components/ClientCheck/ClientCheck';
import GbdflRequest from '../../../components/GbdflRequest/GbdflRequest';
import ClientFcbDocument from './ClientFcbDocument/ClientFcbDocument';
import HookForm from '../../../components/HookForm/HookForm';
import Datepicker from '../../../components/Inputs/Datepicker/Datepicker';
import SelectPhoto from '../NewClient/ClientCreate/SelectPhoto/SelectPhoto';
import Select from '../../../components/Select/Select';
import SelectPhoneType from '../../../components/Selects/SelectPhoneType';
import SelectAddressType from '../../../components/Selects/SelectAddressType';
import SelectSocialType from '../../../components/Selects/SelectSocialType';
import SelectClientType from '../../../components/Selects/SelectClientType';
import SelectCity from '../../../components/Selects/SelectCity';
import SelectKato from '../../../components/Selects/SelectKato';
import Alert from '../../../components/Alert/Alert';
import Loader from '../../../components/Loader/Loader';

// icons
import phoneIcon from '../../../brand/generated/input/phone.svg';

import { iin, phone } from '../../../constants/mask';
import SelectClientID from '../../../components/Selects/SelectClientD';
import SelectClientIssuer from '../../../components/Selects/SelectClientDocumentType';
import {
  CLIENT_DOCUMENT_TYPE,
  CLIENT_NOTARIAL_VERIFICATION_APPROVED,
  CLIENT_NOTARIAL_VERIFICATION_OPTIONS,
} from '../../../constants';
import { resolveIssuer } from '../../../utils/documentIssuer';
import editClientDocuments from '../../../api/clients/editClientDocuments';
import editClient from '../../../api/clients/editClient';
import { toast } from 'react-toastify';
import Button from '../../../components/Button/Button';
import toNameCase from '../../../utils/toNameCase';
import phoneBelongsIinValidate from '../../../api/bmg/phoneBelongsIinValidate';
import { BMG_UNAVAILABLE_MESSAGE } from '../../../utils/clientContact';

const formStyles = {
  mainData: { display: 'grid', gap: '20px', gridTemplateAreas: `'a a a ' 'b b b ' 'k k c' 'd d d'` },
  contacts: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
  },
  document: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: '20px',
  },
  comment: { display: 'grid', gap: '20px' },
};

const ClientMainData = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [photo, setPhoto] = useState();
  const [uploadPhoto, setUploadPhoto] = useState();
  const [isDisableSelectPhoto, setDisableSelectPhoto] = useState(true);
  const [mainData, setMainData] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [comment, setComment] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editClientLoading, setEditClientLoading] = useState(false);
  const [document, setDocument] = useState([]);
  const [vu, setVu] = useState([]);
  const [client, setClient] = useState(null);

  const init = () => {
    setLoading(true)
    getClients({ id })
      .then((res) => {
        const client = res.data.users?.[0];
        if (!client) {
          setLoading(false);
          return;
        }
        // const [day, month, year] = getBirthDateFromIIN(client.iin).split('.');
        const mainData = [
          {
            name: 'surname',
            label: 'Ð¤Ð°Ð¼Ð¸Ð»Ð¸Ñ',
            placeholder: 'Ð¤Ð°Ð¼Ð¸Ð»Ð¸Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
            defaultValue: client.surname,
            transform: toNameCase,
          },
          { name: 'name', label: 'ÐÐ¼Ñ', placeholder: 'ÐÐ¼Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ°', defaultValue: client.name, transform: toNameCase },
          {
            name: 'middlename',
            label: 'ÐÑÑÐµÑÑÐ²Ð¾',
            placeholder: 'ÐÑÑÐµÑÑÐ²Ð¾ (ÐµÑÐ»Ð¸ ÐµÑÑÑ)',
            defaultValue: client.middlename,
            transform: toNameCase,
          },
          {
            name: 'iin',
            label: 'ÐÐÐ',
            placeholder: '_ _ _ _ _ _ _ _ _ _ _',
            mask: iin,
            defaultValue: client?.iin,
          },
          {
            component: Datepicker,
            name: 'born',
            label: 'ÐÐ°ÑÐ° ÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ',
            placeholder: 'Ð´Ð´-Ð¼Ð¼-Ð³Ð³Ð³Ð³',
            defaultValue: client?.born,
          },
          {
            component: Select,
            label: 'Ð¯Ð·ÑÐº',
            placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
            name: 'languageId',
            options: [
              { value: 1, label: 'ÐÐ°Ð·Ð°ÒÑÐ°' },
              { value: 2, label: 'Ð ÑÑÑÐºÐ¸Ð¹' },
            ],
            defaultValue: { value: client?.language?.id, label: client?.language?.title },
          },
          {
            name: 'phoneNumber',
            label: 'ÐÐ¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð°',
            placeholder: '+7(___) ___-__-__',
            mask: phone,
            defaultValue: client?.phone?.[1] === '7' ? client?.phone : client?.phone?.substring(1),
            icon: phoneIcon,
            style: { gridColumn: 3, gridRow: 2, },
          },
          {
            component: Select,
            label: 'ÐÐ¾Ð»',
            placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
            name: 'genderId',
            options: [
              { value: 1, label: 'ÐÑÐ¶ÑÐ¸Ð½Ð°' },
              { value: 2, label: 'ÐÐµÐ½ÑÐ¸Ð½Ð°' },
            ],
            defaultValue: { value: client?.genderId, label: client?.genderId === 1 ? 'ÐÑÐ¶ÑÐ¸Ð½Ð°' : 'ÐÐµÐ½ÑÐ¸Ð½Ð°' },
          },
          {
            component: SelectKato,
            name: 'kato',
            label: 'Ð ÐµÐ³Ð¸Ð¾Ð½',
            defaultValue: client?.kato || undefined,
            style: { gridColumn: '1 / span 2', gridRow: 3, },
          },
          { name: 'registration_street', label: 'Ð£Ð»Ð¸ÑÐ° ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸', placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ ÑÐ»Ð¸ÑÑ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸', defaultValue: client?.registration_street },
          { name: 'registration_house_number', label: 'ÐÐ¾Ð¼', placeholder: 'ÐÐ¾Ð¼ÐµÑ Ð´Ð¾Ð¼Ð°', defaultValue: client?.registration_house_number },
          { name: 'registration_apartment_number', label: 'ÐÐ²Ð°ÑÑÐ¸ÑÐ°', placeholder: 'ÐÐ¾Ð¼ÐµÑ ÐºÐ²Ð°ÑÑÐ¸ÑÑ', defaultValue: client?.registration_apartment_number },
          // {
          //   component: SelectClientType,
          //   name: 'vip',
          //   defaultValue: client.vip ? { value: 1, label: 'VIP' } : { value: 2, label: 'ÐÐ¾ÑÑÐµÐ´Ð½Ð¸Ðº' },
          // },
          {
            component: SelectCity,
            name: 'city',
            label: 'ÐÐ¾ÑÐ¾Ð´',
            defaultValue: { value: client?.city?.id, label: client?.city?.title },
          },
        ];

        const contacts = [
          {
            name: 'email',
            label: 'E-mail',
            placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð°Ð´ÑÐµÑ ÑÐ»ÐµÐºÑÑÐ¾Ð½Ð½Ð¾Ð¹ Ð¿Ð¾ÑÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
            defaultValue: client?.email,
          },
          {
            name: 'url',
            label: 'URL ÑÐ°Ð¹ÑÐ°',
            placeholder: 'Ð¡Ð°Ð¹Ñ ÐºÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ð¸ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
            defaultValue: client?.siteUrl,
          },
        ];
        client?.phones?.forEach((phoneItem, index) => {
          contacts.push(
            {
              component: SelectPhoneType,
              name: `phoneType_${index}`,
              defaultValue: [
                { value: 1, label: 'ÐÐ¾Ð±Ð¸Ð»ÑÐ½ÑÐ¹' },
                { value: 2, label: 'ÐÐ¾Ð¼Ð°ÑÐ½Ð¸Ð¹' },
                { value: 3, label: 'ÐÐ¾ÑÐ¿Ð¾ÑÐ°ÑÐ¸Ð²Ð½ÑÐ¹' },
              ].filter((item) => item.value === phoneItem.typeId)[0],
            },
            {
              name: `phoneNumber_${index}`,
              label: 'ÐÐ¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð°',
              placeholder: '+7(___) ___-__-__',
              mask: phone,
              defaultValue: phoneItem.number.substring(1),
              icon: phoneIcon,
            }
          );
        });
        client?.addresses?.forEach((address, index) => {
          contacts.push(
            {
              component: SelectAddressType,
              name: `addressType_${index}`,
              defaultValue: [
                { value: 1, label: 'ÐÐ¾Ð¼Ð°ÑÐ½Ð¸Ð¹' },
                { value: 2, label: 'ÐÐ¾ÑÐ¿Ð¾ÑÐ°ÑÐ¸Ð²Ð½ÑÐ¹' },
              ].filter((item) => item.value === address.typeId)[0],
            },
            {
              name: `address_${index}`,
              label: 'ÐÐ´ÑÐµÑ',
              placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð°Ð´ÑÐµÑ',
              defaultValue: address.address,
            }
          );
        });
        client?.socials?.forEach((social, index) => {
          contacts.push(
            {
              component: SelectSocialType,
              name: `socialType_${index}`,
              defaultValue: [
                { value: 1, label: 'Facebook' },
                { value: 2, label: 'VK' },
                { value: 3, label: 'Instagram' },
                { value: 4, label: 'Telegram' },
              ].filter((item) => item.value === social.typeId)[0],
            },
            {
              name: `social_${index}`,
              label: '@',
              placeholder: 'ÑÑÑÐ»ÐºÐ°',
              defaultValue: social.value,
            }
          );
        });

        const comments = [];
        client?.comments?.forEach((comment) => {
          comments.push({
            name: 'comment',
            label: 'ÐÐ°Ð¼ÐµÑÐºÐ¸/ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾ ÐºÐ»Ð¸ÐµÐ½ÑÐµ',
            placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð»ÑÐ±ÑÐµ Ð·Ð°Ð¼ÐµÑÐºÐ¸ Ð¸Ð»Ð¸ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾ ÐºÐ»Ð¸ÐµÐ½ÑÐµ',
            defaultValue: comment.comment,
          });
        });

        setDocument([
          {
            component: SelectClientID,
            name: 'document_type_id',
            defaultValue: CLIENT_DOCUMENT_TYPE.find((item) => item.value === client?.document?.document_type_id),
          },
          {
            name: 'document_number',
            label: 'ÐÐ¾Ð¼ÐµÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
            defaultValue: client?.document?.document_number,
            // ÐÐµÐ· Ð½Ð¾Ð¼ÐµÑÐ° Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ° Ð±Ð°Ð½ÐºÐ¸ Ð·Ð°ÑÐ²ÐºÑ Ð½Ðµ Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÑÑ, Ð° Ð¨Ð¸Ð½ÑÐ°Ð½ Ð²Ð¾Ð²ÑÐµ
            // Ð¿Ð°Ð´Ð°Ð». Ð ÑÐ¾ÑÐ¼Ðµ ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð¿Ð¾Ð»Ðµ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ð¾Ðµ, Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ â
            // Ð½Ðµ Ð±ÑÐ»Ð¾, Ð¸ ÐºÐ»Ð¸ÐµÐ½ÑÑ ÑÐ¾ÑÑÐ°Ð½ÑÐ»Ð¸ÑÑ Ñ Ð¿ÑÑÑÑÐ¼ Ð½Ð¾Ð¼ÐµÑÐ¾Ð¼.
            rules: { required: true },
            hint: 'ÐÐ±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ð¾Ðµ Ð¿Ð¾Ð»Ðµ: Ð±ÐµÐ· Ð½Ð¾Ð¼ÐµÑÐ° Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ° Ð·Ð°ÑÐ²ÐºÑ Ð² Ð±Ð°Ð½ÐºÐ¸ Ð¾ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð½ÐµÐ»ÑÐ·Ñ.',
          },
          {
            component: Datepicker,
            name: 'document_date',
            type: 'date',
            label: 'ÐÐ°ÑÐ° Ð²ÑÐ´Ð°ÑÐ¸ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
            defaultValue: client?.document?.document_date,
          },
          {
            component: Datepicker,
            name: 'document_date_end',
            type: 'date',
            label: 'Ð¡ÑÐ¾Ðº Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
            defaultValue: client?.document?.document_date_end,
          },
          {
            component: SelectClientIssuer,
            name: 'document_issuer',
            label: 'ÐÐµÐ¼ Ð²ÑÐ´Ð°Ð½',
            defaultValue: resolveIssuer(client?.document?.document_issuer),
          },
        ]);

        setVu([
          {
            name: 'document_number',
            label: 'ÐÐ¾Ð¼ÐµÑ Ð²/Ñ',
            defaultValue: client?.driver_document?.document_number,
          },
          {
            component: Datepicker,
            name: 'document_date',
            type: 'date',
            label: 'ÐÐ°ÑÐ° Ð²ÑÐ´Ð°ÑÐ¸',
            defaultValue: client?.driver_document?.document_date,
          },
          {
            component: Datepicker,
            name: 'document_date_end',
            type: 'date',
            label: 'Ð¡ÑÐ¾Ðº Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ',
            defaultValue: client?.driver_document?.document_date_end,
          },
        ]);

        setMainData(mainData);
        setContacts(contacts);
        setComment(comments);
        setPhoto(client?.photo);
        setClient(client);
        checkCrmSidebarNotifications({
          notificationIds: client?.notifications?.map(i=>i?.id)
        });
      })
      .finally(() => setLoading(false));
  };

  React.useEffect(() => {
    init();
  }, []);

  // ÐÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¿ÑÐ°Ð²Ð¸Ñ ÐºÐ°ÑÑÐ¾ÑÐºÑ Ð¸ Ð²Ð¾Ð·Ð²ÑÐ°ÑÐ°ÐµÑÑÑ Ðº ÑÐ°Ð±Ð¾ÑÐµ ÑÐ¾ ÑÐ¿Ð¸ÑÐºÐ¾Ð¼: Ð´ÐµÑÐ¶Ð°ÑÑ ÐµÐ³Ð¾
  // Ð½Ð° ÑÑÑÐ°Ð½Ð¸ÑÐµ, ÐºÐ¾ÑÐ¾ÑÑÑ Ð¾Ð½ ÑÐ¶Ðµ ÑÐ¾ÑÑÐ°Ð½Ð¸Ð», Ð½ÐµÐ·Ð°ÑÐµÐ¼. Ð¢Ð°Ðº Ð¶Ðµ Ð²ÐµÐ´ÑÑ ÑÐµÐ±Ñ ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ðµ
  // ÐºÐ»Ð¸ÐµÐ½ÑÐ°.
  const backToClients = () => navigate('/');

  const onClientMainDataSave = async (data) => {
    setEditClientLoading(true);
    const payload = { id };

    for (let i = 0; i < mainData.length; i++) {
      if (mainData[i].name === 'vip') {
        payload.vip = data.vip?.value === 1 ? true : false ?? mainData[i].defaultValue?.value === 1 ? true : false;
      } else if (mainData[i].name === 'phoneNumber') {
        payload.phone = data?.phoneNumber?.replace(/[^\d]/g, '') ?? '7' + mainData[i]?.defaultValue;
      } else {
        payload[mainData[i].name] = mainData[i].value
          ? mainData[i].value?.value ?? mainData[i].value
          : mainData[i].defaultValue?.value ?? mainData[i].defaultValue;
      }
    }

    try {
      const isPhoneBelongsToClient = await phoneBelongsIinValidate({
        phone: payload.phone,
        iin: payload.iin,
      });

      if (!isPhoneBelongsToClient) {
        toast.error('ÐÐ»Ð¸ÐµÐ½Ñ Ñ ÑÑÐ¸Ð¼ ÐÐÐ Ð½Ðµ ÑÐ²Ð»ÑÐµÑÑÑ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐµÐ¼ Ð²Ð²ÐµÐ´ÐµÐ½Ð½Ð¾Ð³Ð¾ Ð½Ð¾Ð¼ÐµÑÐ° ÑÐµÐ»ÐµÑÐ¾Ð½Ð° Ð¸ Ð½Ðµ Ð¿ÑÐ¾ÑÐ¾Ð´Ð¸Ñ Ð¿ÑÐ¾Ð²ÐµÑÐºÑ ÐÐ°Ð·Ñ ÐÐ¾Ð±Ð¸Ð»ÑÐ½ÑÑ ÐÑÐ°Ð¶Ð´Ð°Ð½. ÐÐ¾Ð¿ÑÐ¾ÑÐ¸ÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð¿ÑÐµÐ´Ð¾ÑÑÐ°Ð²Ð¸ÑÑ Ð´ÑÑÐ³Ð¾Ð¹ Ð½Ð¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð°, Ð»Ð¸Ð±Ð¾ Ð¿ÑÐµÐ´Ð»Ð¾Ð¶Ð¸ÑÐµ ÐµÐ¼Ñ Ð¿Ð¾Ð¼ÐµÐ½ÑÑÑ ÑÐ²Ð¾Ð¹ Ð½Ð¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð° Ð² ÐÐ°Ð·Ðµ ÐÐ¾Ð±Ð¸Ð»ÑÐ½ÑÑ ÐÑÐ°Ð¶Ð´Ð°Ð½.');
        setEditClientLoading(false);
        return;
      }
    } catch (e) {
      toast.error(BMG_UNAVAILABLE_MESSAGE);
      setEditClientLoading(false);
      return;
    }

    editProfile({
      ...payload,
      name: toNameCase(data.name?.trim()),
      surname: toNameCase(data.surname?.trim()),
      middlename: toNameCase(data.middlename?.trim()),
    })
      .then(() => {
        toast('ÐÐ°Ð½Ð½ÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ñ');
        backToClients();
      })
      .catch((error) => toast(error.response.data.errorMessage ?? JSON.stringify(error.response)))
      .finally(() => setEditClientLoading(false));
  };

  const onClientContactsSave = (data) => {
    editClient({
      id,
      address: data?.address_0,
      email: data?.email,
      url: data?.url,
    }).then(() => {
      toast('ÐÐ¾Ð½ÑÐ°ÐºÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ñ');
      backToClients();
    });
  };

  const onClientDocumentSave = (data) => {
    console.log(data);
    editClientDocuments({
      id,
      document_type_id: data?.document_type_id?.value,
      document_number: data?.document_number,
      document_date_end: data?.document_date_end,
      document_issuer: data?.document_issuer?.value,
      document_date: data?.document_date,
    }).then(() => {
      toast('ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ñ');
      backToClients();
    });
  };

  const onClientCommentSave = (data) => {
    // const payload = { comment: data.comment ?? comment[0].defaultValue };
  };

  const addValuesContactsForm = (array, isPhoneNumber) => {
    const formatPhoneNumber = (number) => {
      if (!number) return;
      const phoneNumber = number.replace(/[^\d]/g, '');
      const result = [];
      for (let i = phoneNumber.length; result.length <= 10; i--) {
        result.push(phoneNumber[i]);
      }
      return '7' + result.reverse().join('');
    };

    const result = [];
    for (let i = 0; i < array.length; i += 2) {
      if (array[i].value) {
        result.push({
          type: array[i].value?.value,
          value: isPhoneNumber
            ? formatPhoneNumber(array[i + 1].value) ?? formatPhoneNumber(array[i + 1].defaultValue)
            : array[i + 1].value ?? array[i + 1].defaultValue,
        });
        break;
      }
      if (array[i].defaultValue) {
        result.push({
          type: array[i].defaultValue?.value,
          value: isPhoneNumber
            ? formatPhoneNumber(array[i + 1].value) ?? formatPhoneNumber(array[i + 1].defaultValue)
            : array[i + 1].value ?? array[i + 1].defaultValue,
        });
      }
    }
    return result;
  };

  const sellCar = () => {
    navigate("/deals/create", { state: { client } })
  }

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {editClientLoading && <Loader />}
          <div className={styles.wrapper}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <SelectPhoto
                photo={photo}
                setPhoto={setPhoto}
                setUploadPhoto={setUploadPhoto}
                style={{ flex: 1 }}
                disabled={isDisableSelectPhoto}
              />
              <p className={styles.date} style={{ margin: '20px 0' }}>
                ÐÐ»Ð¸ÐµÐ½Ñ Ð·Ð°ÑÐµÐ³Ð¸ÑÑÑÐ¸ÑÐ¾Ð²Ð°Ð½: <span>01.09.2022</span>
              </p>
              <ClientCheck
                list={[
                  {
                    title: 'ÐÐ¾ÑÐ°ÑÐ¸ÑÑ',
                    statusLabel: CLIENT_NOTARIAL_VERIFICATION_OPTIONS?.find(
                      (item) => item?.value === client?.notarial_verification
                    )?.label,
                    color: '#6A6A6A',
                  status:
                      client?.notarial_verification == 1
                        ? 'pending'
                        : client?.notarial_verification == 2
                        ? 'success'
                        : 'reject',
                  },
                ]}
                onRefresh={init}
              />
              <Button text="ÐÑÐ¾Ð´Ð°ÑÑ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ" fill style={{marginTop: 15}} onClick={sellCar}/>
              <GbdflRequest clientId={id} onUpdated={init} />
            </div>
            <div className={styles.forms}>
              <HookForm
                title={'ÐÐ°Ð½Ð½ÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ°'}
                grid={formStyles.mainData}
                border
                inputs={mainData}
                style={{ margin: 0 }}
                action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ'}
                onSubmit={onClientMainDataSave}
                responsiveForm
              />
              <HookForm
                title={'ÐÐ¾Ð½ÑÐ°ÐºÑÐ½ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ'}
                grid={formStyles.contacts}
                border
                inputs={contacts}
                style={{ margin: 0 }}
                isClientCreate
                action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ'}
                onSubmit={onClientContactsSave}
                responsiveForm
              />
              <HookForm
                title={'ÐÐ°Ð½Ð½ÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð²'}
                grid={formStyles.document}
                border
                inputs={document}
                style={{ margin: 0 }}
                onSubmit={onClientDocumentSave}
                action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ'}
                responsiveForm
                subtitle={() => (
                  <ClientFcbDocument
                    embedded
                    clientId={id}
                    iin={client?.iin}
                    phone={client?.phone}
                    onSuccess={init}
                  />
                )}
              />
              {/* <HookForm
                title={'ÐÐ°Ð½Ð½ÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð²'}
                grid={formStyles.document}
                border
                inputs={vu}
                style={{ margin: 0 }}
                onSubmit={onClientDocumentSave}
                action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ'}
              />
              <HookForm
                title={'ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾'}
                border
                grid={formStyles.comment}
                inputs={comment}
                style={{ margin: 0 }}
                isClientCreate
                action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ'}
                onSubmit={onClientCommentSave}
              /> */}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ClientMainData;
